module.exports = {
      id: "food-stylist-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#food-stylist",
      toString: function () {
        return this.url;
      }
    }